import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Register = () => {
  const handleClick = e => {
    e.preventDefault()
    alert(
      "Thanks for attempting to sign up! Unfortunately, Finnick is not a real service. \n\nNone of this information has been saved."
    )
  }

  return (
    <Wrapper>
      <Container>
        <h1>Let's make it rain.</h1>
        <form action="" onSubmit={e => handleClick(e)}>
          <Inputs>
            <input type="text" placeholder="First name*" required />
            <input type="text" placeholder="Last name*" required />
            <input type="email" placeholder="Email*" required />
            <input
              type="password"
              placeholder="Create password*"
              minlength="8"
              required
            />
          </Inputs>
          <p>Password must be at least 8 characters long.</p>
          <input type="checkbox" id="agreements" required />
          <label htmlFor="agreements">
            I agree to the <span>Terms & Conditions</span> and{" "}
            <span>Privacy Policy</span>
          </label>
          <button>Create Account</button>
          <p>
            Already have an account?{" "}
            <Link to="/login" style={{ color: "#5fcc9c" }}>
              Log in
            </Link>
          </p>
        </form>
      </Container>
      <StaticImage
        src="../images/motivation.png"
        alt=""
        quality="100"
        placeholder="tracedSVG"
      />
    </Wrapper>
  )
}

export default Register

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px;

  @media screen and (min-width: 900px) {
    flex-direction: row-reverse;
  }
`

const Container = styled.div`
  max-width: 500px;

  @media screen and (min-width: 900px) {
    margin-left: 5vw;
  }

  p {
    margin-top: 10px;
  }

  input[type="checkbox"] {
    margin: 15px 0;
  }

  label {
    margin-left: 5px;
  }

  button {
    width: 100%;
    background-color: #5fcc9c;
    border: 1px solid #5fcc9c;
    border-radius: 5px;
    padding: 10px;
    font-size: 1.2rem;
    color: #fff;
    cursor: pointer;
  }

  span {
    color: #5fcc9c;
    text-decoration: underline;
    cursor: pointer;
  }
`

const Inputs = styled.div`
  margin-top: 10px;

  input {
    padding: 12px;
    width: calc(50% - 5px);
    border: 1px solid #251a41;
    border-radius: 5px;
    font-size: 1rem;
  }

  input:nth-child(2) {
    margin-left: 10px;
  }

  input:nth-child(3),
  input:nth-child(4) {
    width: 100%;
    margin-top: 10px;
  }
`
